import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db0b87ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0b87ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db0b87ba')) {
      api.createRecord('db0b87ba', component.options)
    } else {
      api.reload('db0b87ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=db0b87ba&scoped=true", function () {
      api.rerender('db0b87ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/sign/index.vue"
export default component.exports